// Called by : src/App.vue (modal-cgu)

<template>
  <base-modal ref="base-modal" pageId="pge_cgu" pageClass="infos" modalClass="modal-lg modal-dialog-scrollable" modalDataBack="static" modalDataKey="false">

      <template #header>
        <h4 class="modal-title" id="pge_cgu_title">{{ $t('infos.cguTitle') }}</h4>
        <button v-if="user.cguOk" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>

      <template #body>
        <div v-html="paramsCgu"></div>
      </template>

      <template #footer>
        <div v-if="user.cguOk" class="w-100">
          <button type="submit" class="btn btn-secondary btn-lg bnt-block w-100" data-dismiss="modal">
            <span class="oi oi-x mr-2"></span>
            {{ $t('modals.close') }}
          </button>
        </div>
        <div v-else class="w-100">
          <div class="btn-group bnt-block w-100">
              <button class="btn btn-secondary btn-lg" data-dismiss="modal" @click="refuse" style="width:30%;">
                <span class="oi oi-ban mr-2"></span>
                {{ $t('modals.cancel') }}
              </button>
              <button class="btn btn-primary btn-lg" data-dismiss="modal" @click="accept" style="width:70%;">
                <span class="oi oi-check mr-2"></span>
                {{ $t('modals.approved') }}
              </button>
          </div>
        </div>
      </template>

  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModal'

export default {
  components: {
    BaseModal,
  },
  methods: {
    accept() {
      this.model.setUserAcceptCgu(this.user)
      this.user.cguOk = Boolean(1)
    },
    refuse() {
      this.$router.push({name: 'connect'})
    }
  },
  computed: {
    paramsCgu() {
      return f_setCguFormats_s(this.$store.state.params.cgu)
    },
    model() {
      return this.$store.state.model
    },
    user() {
      return this.$store.state.user
    },
  },
}
</script>

<style scoped>
  /* void */
</style>



// WEBPACK FOOTER //
// src/components/misc/ModalCgu.vue